export default async function wait(timeInMillis: number) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(true), timeInMillis)
  });
}